export const site = {
  practitioner: {
    name: "Lea Walchshauser",
    credentials: "LMFT",
    licenseNumber: "53663",
    fullTitle: "Lea Walchshauser, LMFT",
    fullTitleWithLicense: "Lea Walchshauser, LMFT 53663",
    location: "California (Telehealth statewide)",
  },
  tagline: "Insight. Regulation. Meaningful change.",
  description:
    "Integrative psychotherapy combining Brainspotting, somatic, systemic, and solution-focused approaches.",
  links: {
    headway:
      "https://care.headway.co/providers/lea-walchshauser?utm_source=pem&utm_medium=direct_link&utm_campaign=79264",
    alma: "https://secure.helloalma.com/providers/lea-walchshauser/",
    psychologyToday:
      "https://www.psychologytoday.com/us/therapists/lea-walchshauser-san-diego-ca/886691",
    psychologyTodayProfile: "https://www.psychologytoday.com/profile/886691",
    brainspottingDirectory: "https://brainspotting.com/directory/",
    linkedIn: "https://www.linkedin.com/in/lea-walchshauser-22467611",
  },
} as const;

export type NavItem = { label: string; to: string };

export const primaryNav: NavItem[] = [
  { label: "About", to: "/about" },
  { label: "Who I Work With", to: "/who-i-work-with" },
  { label: "Areas of Focus", to: "/areas-of-focus" },
  { label: "Modalities", to: "/modalities" },
  { label: "Supervision", to: "/supervision" },
  { label: "Fees & Insurance", to: "/fees" },
  { label: "Contact", to: "/contact" },
];
